export const TERMS_AND_CONDITIONS_URL = 'https://www.mykuya.com/terms-of-use/'; 
export const PRIVACY_POLICY_URL = 'https://www.mykuya.com/privacy-policy';
export const HELP_CENTER_URL = 'https://help.mykuya.com/hc/en-us';
export const ABOUT_US_URL = 'https://mykuya.com/about';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mykuyauserapp&hl=en_US';
export const ENTERPRISE_SOLUTION_URL = 'https://mykuya.com/enterprise';
export const ENTERPRISE_PARTNERS_URL = 'https://www.mykuya.com/enterprise-partners';
export const MYKUYA_URL = 'https://mykuya.com/';